import React, { useState, useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Dialog } from "../../../components/Dialogs/Dialog";
import { QuickReplyTemplateListV2 } from "../QuickReplyTemplateListV2";
import { ManageQuickReplyTemplate } from "../ManageQuickReplyTemplate";

interface ISelectQuickReplyTemplateProps {
  open: boolean;
  toNumber: string;
  onClose: () => void;
  onSelectTemplate?: (message: string) => void;
}

export const SelectQuickReplyTemplate: React.FC<
  ISelectQuickReplyTemplateProps
> = (props) => {
  const { open, toNumber, onClose, onSelectTemplate } = props;
  const [searchTemplateName, setSearchTemplateName] = useState("");
  const [showCreatePanel, setShowCreatePanel] = useState(false);
  const refetchRef = useRef<(() => void) | null>(null);

  const handleToggleCreatePanel = () => {
    setShowCreatePanel((prev) => !prev);
  };

  const handleSaveSuccess = () => {
    setShowCreatePanel(false);
    // Refetch the template list after successful creation
    if (refetchRef.current) {
      refetchRef.current();
    }
  };

  return (
    <Dialog
      size="xl"
      open={open}
      onClose={onClose}
      title={"Select Quick Reply Template"}
    >
      <Box
        sx={{
          display: "flex",
          gap: 3,
          minHeight: "60vh",
          maxHeight: "75vh",
          overflow: "hidden",
        }}
      >
        {/* Left Panel - Template List */}
        <Box
          sx={{
            width: showCreatePanel ? "55%" : "100%",
            flexShrink: 0,
            overflow: "auto",
            transition: "width 0.25s ease-out",
          }}
        >
          <QuickReplyTemplateListV2
            selectedTemplateUuid={null}
            showCreateButton={false}
            searchTemplateName={searchTemplateName}
            onSearchChange={setSearchTemplateName}
            toNumber={toNumber}
            isFromChat={true}
            onClose={onClose}
            onCreateClick={handleToggleCreatePanel}
            hideCreateButton={showCreatePanel}
            compactCardsView={showCreatePanel}
            refetchRef={refetchRef}
            onSelectTemplate={onSelectTemplate}
          />
        </Box>

        {/* Right Panel - Create Template Form */}
        {showCreatePanel && (
          <Box
            sx={{
              width: "42%",
              flexShrink: 0,
              overflow: "auto",
              borderLeft: "1px solid",
              borderColor: "divider",
              pl: 3,
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
                position: "sticky",
                top: 0,
                backgroundColor: "background.paper",
                zIndex: 1,
                pb: 1,
              }}
            >
              <Typography variant="h5" fontWeight={600}>
                Create Quick Reply Template
              </Typography>
              <IconButton
                size="small"
                onClick={handleToggleCreatePanel}
                sx={{ color: "text.secondary" }}
              >
                <Close />
              </IconButton>
            </Box>
            <ManageQuickReplyTemplate
              fromRightPanel
              onSaveSuccess={handleSaveSuccess}
              templateData={undefined}
            />
          </Box>
        )}
      </Box>
    </Dialog>
  );
};
